import {
  Box,
  BoxProps,
  createStyles,
  DefaultProps,
  MantineNumberSize,
  Text,
} from '@mantine/core';
import React, { ExoticComponent, ReactFragment, useMemo } from 'react';

const useStyles = createStyles((_theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  priceText: {
    fontWeight: 700,
    lineHeight: 1.1,
  },
  priceContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    gap: '3px',
    flexWrap: 'wrap',
    textAlign: 'right',
  },
  defaultCursor: {
    cursor: 'default',
  },
}));

const Price2 = (props: {
  preText?: React.ReactNode;
  postText?: React.ReactNode;
  children?: any;
  style?: object;
  className?: string;
  ref?: React.Ref<HTMLDivElement>;
}) => {
  const { preText, postText, children, style, ...rest } = props;
  const { classes } = useStyles();
  return (
    <Box
      className={`${classes.container} ${props.className || ''}`}
      style={style}
      ref={props.ref}
    >
      <Text c="dimmed" size="sm" className="preText">
        {preText}
      </Text>
      {children}
      <Text c="dimmed" size="xs" className="PostText">
        {postText}
      </Text>
    </Box>
  );
};

Price2.Price = (
  props: {
    label?: React.ReactNode;
    reverseLabel?: boolean;
    children?: React.ReactNode;
    size?: MantineNumberSize;
    container?: React.ElementType | typeof React.Fragment;
  } & Partial<Omit<React.ComponentProps<typeof Box> & BoxProps, 'label'>>,
) => {
  const {
    label = '1. Jahr',
    children = '0,00 €',
    size = 24,
    container,
    reverseLabel = false,
    ...rest
  } = props;
  const { classes } = useStyles();

  const Container = useMemo(() => {
    if (!container)
      return (props) => (
        <Box {...props} className={classes.priceContainer} {...rest} />
      );
    const C = container;

    return (props) => <C {...props} {...rest} />;
  }, [container, rest]);

  const labelElement = (
    <Text
      c="dimmed"
      size="xs"
      className={`priceLabel ${classes.defaultCursor}`}
    >
      {label}
    </Text>
  );

  return (
    <Container>
      {!reverseLabel && labelElement}
      <Text
        c="primary"
        className={`priceValue ${classes.priceText} ${classes.defaultCursor}`}
        size={size}
      >
        {children}
      </Text>
      {reverseLabel && labelElement}
    </Container>
  );
};

export default Price2;
